const internalPaths = [
  "/chats",
  "/discover",
  "/more/feedback-info",
  "/network-home",
  "/notifications",
  "/preferences",
  "/premium",
  "/stories",
  "/xingternal/demo",
  "/xingternal/feature-switches",
  "/xingternal/platform-showcase",
  "/xingternal/platform",
  "/xingternal/search",
  "/you",
  "/onboarding"
];
export {
  internalPaths
};
